// src/config.js
// Single source of truth for your backend base URL (Create React App)
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

export default API_BASE_URL;
